import {combineReducers} from "redux";
import currentUser from "./token/login";
import routerHistory from "./router/router.js";
import modal from "./modal";
import page from "./page";
import alerts from "./alert";

const reduserApp = combineReducers({
    currentUser,
    routerHistory,
    modal,
    page,
    alerts
});

export default reduserApp;